document.addEventListener('DOMContentLoaded', async () => {
  const tokenMeta = document.querySelector('meta[name="sf-token"]');
  const STOREFRONT_TOKEN = tokenMeta ? tokenMeta.content.trim() : '';
  const STORE_DOMAIN = window.Shopify?.shop || location.hostname;

  if (!STOREFRONT_TOKEN) {
    console.error("🚫 Missing storefront token (meta[name='sf-token'])");
    return;
  }

  const holders = document.querySelectorAll('.product-card__swatches');
  if (!holders.length) return;

  // Translated storefronts: ask the Storefront API for the same language as the page
  const LANG = window.lyLanguageCode && window.lyPrimaryLocale === false ? window.lyLanguageCode : null;

  // ✅ Corrected GraphQL query
  const query = `
    query getVariants($ids: [ID!]!${LANG ? ', $language: LanguageCode' : ''})${LANG ? ' @inContext(language: $language)' : ''} {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          title
          image { src altText }
          product {
            handle
            title
            metafield(namespace: "custom", key: "colour_swatch") {
              references(first: 10) {
                nodes {
                  ... on Metaobject {
                    type
                    fields {
                      key
                      value
                      reference {
                        __typename
                        ... on MediaImage {
                          image {
                            src
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          selectedOptions { name value }
        }
      }
    }
  `;

  async function gqlFetch(ids) {
    const formatted = ids.map((id) => (id.startsWith('gid://') ? id : `gid://shopify/ProductVariant/${id}`));

    try {
      const res = await fetch(`https://${STORE_DOMAIN}/api/2025-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query, variables: LANG ? { ids: formatted, language: LANG } : { ids: formatted } }),
      });

      const json = await res.json();
      return json.data?.nodes?.filter(Boolean) || [];
    } catch (err) {
      console.error('❌ gqlFetch failed:', err);
      return [];
    }
  }

  // One batched Storefront request for every card on the page (previously one
  // awaited request per card, run in series - up to 24 round trips on a grid).
  // `nodes` accepts max 250 IDs per call, so chunk and run chunks in parallel.
  const toGid = (id) => (id.startsWith('gid://') ? id : `gid://shopify/ProductVariant/${id}`);
  const holderGids = new Map();
  holders.forEach((holder) => {
    const raw = holder.dataset.variantGids;
    if (!raw) return;
    try {
      const gids = JSON.parse(raw.replace(/&quot;/g, '"')).filter(Boolean).map(toGid);
      if (gids.length) holderGids.set(holder, gids);
    } catch (err) {
      console.error('❌ swatches: bad data-variant-gids', err);
    }
  });

  const allGids = [...new Set([...holderGids.values()].flat())];
  if (!allGids.length) return;

  const CHUNK = 250;
  const chunks = [];
  for (let i = 0; i < allGids.length; i += CHUNK) chunks.push(allGids.slice(i, i + CHUNK));
  const variantById = new Map();
  (await Promise.all(chunks.map(gqlFetch))).flat().forEach((v) => variantById.set(v.id, v));

  for (const [holder, gids] of holderGids) {
    const variants = gids.map((id) => variantById.get(id)).filter(Boolean);

    if (!variants.length) continue;

    // Group variants by color name
    const colorNames = ['colour', 'color', 'colour options', 'color options'];
    const colorMap = {};

    variants.forEach((v) => {
      const opt = (v.selectedOptions || []).find((o) => (colorNames.includes(o.name.toLowerCase()) || window.lyIsOption(o.name, 'colour')));
      if (!opt) return;
      const key = opt.value.trim();
      if (!colorMap[key]) colorMap[key] = v;
    });

    const uniqueVariants = Object.values(colorMap);
    if (!uniqueVariants.length) continue;

    const container = document.createElement('div');
    container.className = 'swatch-holder';

    uniqueVariants.forEach((v) => {
      const opt = (v.selectedOptions || []).find((o) => (colorNames.includes(o.name.toLowerCase()) || window.lyIsOption(o.name, 'colour')));
      const colorValue = opt ? opt.value : null;
      const variantId = v.id.replace('gid://shopify/ProductVariant/', '');
      const href = window.lyUrl(`products/${v.product.handle}?variant=${variantId}`);

      const a = document.createElement('a');
      a.href = href;
      a.title = colorValue || v.title;
      a.className = 'swatch';

      // 🟩 Try metafield first
      let imageUrl = null;
      let hexCode = null;
      const mfNodes = v.product?.metafield?.references?.nodes || [];

      if (mfNodes.length) {
        for (const field of mfNodes[0].fields) {
          if (field.key === 'image' && field.reference?.image?.src) {
            imageUrl = field.reference.image.src;
          }
          if (field.key === 'hexcode' && field.value) {
            hexCode = field.value;
          }
        }
      }

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = colorValue || '';
        img.loading = 'lazy';
        img.className = 'swatch-image';
        a.appendChild(img);
      } else if (hexCode) {
        const span = document.createElement('span');
        span.style.backgroundColor = hexCode;
        span.className = 'swatch-item';
        a.appendChild(span);
      } else if (v.image?.src) {
        const img = document.createElement('img');
        img.src = v.image.src;
        img.alt = colorValue || '';
        img.loading = 'lazy';
        img.className = 'swatch-image';
        a.appendChild(img);
      } else {
        const span = document.createElement('span');
        span.className = 'swatch-item';
        a.appendChild(span);
      }

      container.appendChild(a);
    });

    holder.appendChild(container);
  }
});
